module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-2019-tablet-738x100.cf930b44.jpg";